import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";
import { Sedes } from "@/components/sedes";

export const Route = createFileRoute("/contacto")({
  head: () => ({
    meta: [
      { title: "Contacto | Mine Class" },
      { name: "description", content: "Conversemos sobre cómo Mine Class puede ayudar a tu operación." },
    ],
    links: [{ rel: "canonical", href: "/contacto" }],
  }),
  component: ContactoLayout,
});

function ContactoLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const tabs = [
    { to: "/contacto/formulario", label: "Formulario", icon: "mail" },
    { to: "/contacto/reunion", label: "Agendar reunión", icon: "event_available" },
  ] as const;

  return (
    <SubPage
      eyebrow="Contacto"
      title="Hablemos de tu operación"
      intro="Escríbenos o agenda una reunión con un especialista B2B."
    >
      <div className="not-prose mb-8 flex flex-wrap gap-2 border-b border-[var(--color-outline-variant)]">
        {tabs.map((t) => {
          const active = pathname === t.to || (t.to === "/contacto/formulario" && pathname === "/contacto");
          return (
            <Link
              key={t.to}
              to={t.to}
              className={[
                "inline-flex items-center gap-2 px-5 py-3 -mb-px border-b-2 font-bold uppercase tracking-widest text-sm transition-colors",
                active
                  ? "border-[var(--color-brand-coral)] text-[var(--color-brand-purple)]"
                  : "border-transparent text-[var(--color-on-surface-variant)] hover:text-[var(--color-brand-purple)]",
              ].join(" ")}
            >
              <span className="material-symbols-outlined text-base">{t.icon}</span>
              {t.label}
            </Link>
          );
        })}
      </div>

      <Outlet />

      <div className="mt-16">
        <Sedes />
      </div>
    </SubPage>
  );
}
